import { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import "./Musica.css"

// Establece el elemento de la aplicación para el modal
Modal.setAppElement('#root');

function AgregarMusica() {
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar la visibilidad del modal

  const handleOpenModal = () => {
    setIsModalOpen(true); // Abrir el modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Cerrar el modal
  };

  return (
    <div className="bg-cover bg-center bg-no-repeat bg-fixed" style={{ backgroundImage: `url(${require('../../Imagenes/5.png')})` }}>
      <div className="p-8 text-center">
        <div className="flex flex-col items-center bg-verde3 rounded-lg">
          <h2 className="font-Libre-Baskerville text-white text-3xl md:text-5xl text-center mt-6">Música</h2>

          <div className='flex justify-center items-center mb-10 mt-10'>
            <Fade cascade={true} duration={3000}>
              <FontAwesomeIcon icon={faMusic} size="5x" className="text-white" />
            </Fade>
          </div>

          <div className="text-1xl font-bold text-white mb-4 ml-7 mr-7 text-center">
            <p>¿Cuál es la canción que no debe faltar en la fiesta?</p>
          </div>

          <Fade direction="left">
            <button
              className="font-bold text-lg text-white mb-10 bg-verde2 rounded-md px-6 py-2 transition-colors duration-300 ease-in-out hover:bg- focus:outline-none focus:ring-2 focus:ring- focus:ring-opacity-50"
              onClick={handleOpenModal} // Abre el modal en lugar de redirigir
            >
              Sugerir canción
            </button>
          </Fade>
        </div>
      </div>

      {/* Modal para el formulario de Google */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Sugerir Canción"
        className="modal"
        overlayClassName="overlay"
      >
        <h2 className="text-center text-xl font-bold mb-4">Sugerir Canción</h2>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSc9yR7WVX6dPQpRL61NiHr6JOrdYUQuB5cA4mTdFfDOvMiguQ/viewform?usp=sharing&ouid=113947223408579372962" // Enlace al formulario de Google
          width="100%"
          height="500px"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Formulario de Sugerencia de Canciones"
        >
          Cargando…
        </iframe>
        <button
          onClick={handleCloseModal}
          className="mt-4 bg-verde2 text-white rounded-md px-4 py-2"
        >
          Cerrar
        </button>
      </Modal>
    </div>
  );
}

export default AgregarMusica;
